export default __webpack_public_path__ + "static/assets/med_pill_round_flat_L2_solid_l_01_f.4ca015b1.png";